import i18n from "../../../lang/base";
import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import { DropdownType } from "../../base/CustomDropdown";
import SecurityGroupRuleAdd from "./SecurityGroupRuleAdd";

export interface SecurityGroupRuleData {
    security_group_rule_id: string,
    security_group_rule_type_code: string,
    direction_type_code: string,
    open_port_type_code: string,
    remote_type_code: string,
    min_port: number,
    max_port: number,
    remote_cidr: string|null,
    ip_protocol: number,
    security_group_rule_type: {
        security_group_rule_type_code: string,
        ip_protocol: number,
    },
    security_group: {
      security_group_id: string,
      security_group_name: string
    },
    remote_security_group_id: string|null,
    remote_security_group_name: string|null,
    project: {
      project_id: string,
      project_name: string
    },
    create_ts: string,
    update_ts: string
  }

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("RULE_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "SECURITY_GROUP_RULE_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "SECURITY_GROUP_RULE_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "SECURITY_GROUP_RULE_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("DIRECTION_TEXT"),
        accessor: "direction_type_code",
        disableSortBy: false,
        style: {
            width: "50px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={className.normalTextContainer}>
            {value === "IN" ? "Inbound" : "Outbound"}
        </div>)
    },
    {
        Header: i18n.t("SECURITY_GROUP_RULE_TYPE_TEXT"),
        accessor: "security_group_rule_type",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={className.normalTextContainer}>
            {value.security_group_rule_type_code === "CUSTTCP" ? "사용자 정의 TCP 규칙" 
            : value.security_group_rule_type_code === "CUSTUDP" ? "사용자 정의 UDP 규칙"
            : value.security_group_rule_type_code === "CUSTICMP" ? "사용자 정의 ICMP 규칙"
            : value.security_group_rule_type_code === "OTHER" ? "다른 프로토콜"
            : value.security_group_rule_type_code}
            {value.ip_protocol ? "(" + value.ip_protocol + ")" : ""}
        </div>)
    },
    {
        Header: i18n.t("SECURITY_GROUP_RULE_IP_TEXT"),
        accessor: "",
        disableSortBy: true,
        style: {
            width: "40px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{...className.normalTextContainer, ...className.greenText}}>
            {"IPv4"}
        </div>)
    },
    {
        Header: i18n.t("PORT_TYPE_TEXT"),
        accessor: "open_port_type_code",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{...className.normalTextContainer, ...className.dateContainer}}>
            {value === "SINGLE" ? "단일 포트" 
            : value === "MULTI" ? "포트 범위"
            : "모든 포트"}
        </div>)
    },
    {
        Header: i18n.t("PORT_INFO_TEXT"),
        accessor: "port",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value, row} }) => (
        <div style={{...className.normalTextContainer, ...className.blueText}}>
            {value.open_port_type_code === "MULTI" ? value.min_port + '-' + value.max_port : value.open_port_type_code === "SINGLE" ? value.min_port : "전체"}
        </div>)
    },
    {
        Header: i18n.t("SECURITY_GROUP_RULE_CONNECT_TYPE_TEXT"),
        accessor: "remote_type_code",
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={className.normalTextContainer}>
            {value === "CIDR" ? "CIDR" : "다른 보안 그룹" }
        </div>)
    },
    {
        Header: i18n.t("CIDR_TEXT"),
        accessor: "remote_cidr",
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#5c5c5c"}}>{value ? value : ""}</div>)
    },
    {
        Header: i18n.t("SECURITY_GROUP_TEXT"),
        accessor: "remote_security_group_name",
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.purpleText}}>{value ? value : ""}</div>)
    },
];

export const securityGroupRuleAddModalContent = {
    title: i18n.t("SECURITY_GROUP_RULE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <SecurityGroupRuleAdd />,
}


export const ruleTypes:DropdownType[] = [
    {
        label: "사용자 정의 TCP 규칙",
        value: "CUSTTCP"
    },
    {
        label: "사용자 정의 UDP 규칙",
        value: "CUSTUDP"
    },
    {
        label: "사용자 정의 ICMP 규칙",
        value: "CUSTICMP"
    },
    {
        label: "전체 ICMP",
        value: "ALLICMP"
    },
    {
        label: "전체 TCP",
        value: "ALLTCP"
    },
    {
        label: "전체 UDP",
        value: "ALLUDP"
    },
    {
        label: "다른 프로토콜",
        value: "OTHER"
    },
    {
        label: "DNS",
        value: "DNS"
    },
    {
        label: "HTTP",
        value: "HTTP"
    },
    {
        label: "HTTPS",
        value: "HTTPS"
    },
    {
        label: "IMAP",
        value: "IMAP"
    },
    {
        label: "IMAPS",
        value: "IMAPS"
    },
    {
        label: "MS_SQL",
        value: "MSSQL"
    },
    {
        label: "MYSQL",
        value: "MYSQL"
    },
    {
        label: "POP3",
        value: "POP3"
    },
    {
        label: "POP3S",
        value: "POP3S"
    },
    {
        label: "RDP",
        value: "RDP"
    },
    {
        label: "SMTP",
        value: "SMTP"
    },
    {
        label: "SMTPS",
        value: "SMTPS"
    },
    {
        label: "SSH",
        value: "SSH"
    },
]

export const portTypes:DropdownType[] = [
    {
        label: "단일 포트",
        value: "SINGLE"
    },
    {
        label: "포트 범위",
        value: "MULTI"
    },
    {
        label: "모든 포트",
        value: "ALL"
    },
]

export const connectTypes:DropdownType[] = [
    {
        label: "CIDR",
        value: "CIDR"
    },
    {
        label: "보안 그룹",
        value: "SG"
    },
]

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 1,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    greenText: {
        color: "#3a8344"
    },
    blueText: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
}